<template>
  <div class="animated fadeIn" style="min-height:900px;display:flex;
  flex-flow:column;height:100%;">
    <!-- Cancellations -->
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col>
          <b-card class="border-0">
            <div class="card-text">
              <div class="d-flex flex-row justify-content-start py-2 py-lg-2 py-md-2">
                <div class="text-dark mr-3"><i class="el-icon-success headericon"></i></div>
                <div class="h4 font-weight-bold text-dark">Indhent flere anbefalinger</div>
              </div>
              <div class="pt-0 pr-1 pl-1 open-sans line-height-golden h5">
                  Vi oplever at anbefalinger af håndværkernes udførte arbejde i stigende grad spiller en rolle, når bygherre skal vælge håndværkere.<br><br>Håndværker.dk gør det nu muligt for dig at øge dine chancer for succes ved at lade dine kunder, som du har løst opgaver for uden om vores system, anbefale dit arbejde. Alt du skal gøre er at indtaste din kundes navn og e-mailadresse og klikke på linket.<br><br>Der er ikke begrænsning på antallet af kunder, som du kan sende til.
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <haandvaerker></haandvaerker>
    <b-container fluid class="pt-0 pr-3 pb-0 pl-3">
      <b-row no-gutters class="d-flex justify-content-start align-items-stretch bg-white h-100">
        <b-col sm="12" md="12" lg="12">
          <b-card class="border-0">
            <div class="card-text">
              <b-form @submit.stop.prevent="service_jule_action">
                <b-form-row>
                  <b-col>
                    <div class="h5 font-weight-bold headerfont mb-3 text-dark">Tilføj kundens navn og e-mail eller mobil her</div>
                  </b-col>
                </b-form-row>
                <div class="py-2"></div>
                <b-form-row v-for="(customer, index) in customers" :key="index">
                  <b-col sm="12" md="12" lg="3">
                    <b-form-group  label="Navn" >
                      <b-form-input  type="text"  v-model="customer.name" name="customers[][name]" required class="rounded"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="12" lg="3">
                    <b-form-group label="E-mail" >
                      <b-form-input  type="email"  v-model="customer.email" name="customers[][email]"  class="rounded"></b-form-input>
                    </b-form-group>
                  </b-col>
                    <b-col sm="12" md="12" lg="3">
                        <b-form-group label="Mobil" >
                            <b-form-input  type="tel"  v-model="customer.mobile" name="customers[][mobile]"  class="rounded"></b-form-input>
                        </b-form-group>
                    </b-col>
                  <b-col sm="12" md="12" lg="2">
                    <div class="py-3"></div>
                    <b-button size="sm" class="rounded" @click="delCustomer(index)" variant="outline-danger"  v-if="index !== 0">
                      <span class="far fa-trash-alt"></span>
                    </b-button>
                    <b-button size="sm" class="rounded ml-2" @click="addCustomer()" variant="outline-success" >
                      <span class="el-icon-circle-plus"></span>
                    </b-button>
                      <div class="py-2"></div>
                  </b-col>
                </b-form-row>

                  <div class="py-3"></div>
                  <b-col  sm="12" md="12" lg="8">
                      <div class="d-flex justify-content-center">
                          <b-btn size="lg" type="submit" class="rounded flex justify-center items-center" variant="success">
                            <span class="mr2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-circle-right-f"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z' /></svg></span> Send
                          </b-btn>
                      </div>
                  </b-col>

              </b-form>
            </div>


          </b-card>
        </b-col>
      </b-row>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </b-container>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import loading from 'vue-full-loading'
import Haandvaerker from './haandvaerker'
import Vue from 'vue'
export default {
  name: 'jule',
  components: {
    loading,
    Haandvaerker,
    Simplert,
    Vue
  },
  data () {
    return {
      selected: '',
      salesPerson: '',
      imgPicked: '',
      consent: '0',
      show: false,
      label: 'Loading...',
      overlay: 1,
      modalShowMail: false,
      isLoadingMail: false,
      items: [],
      images: [],
      textReason: '',
      url: '',
      startend: '',
      finishend: '',
      imageSelect: '',
      message: '',
      haaCredit: false,
      opsige: false,
      Canexpire: true,
      showimentor: true,
      opsigedone: false,
      showDismissibleAlert: false,
      customer: {
        name: '',
        email: '',
        mobile: ''
      },
      customers: []
    }
  },
  methods: {
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res
            this.images = res.resultImages
            if (this.images.length !== 0) {
              this.imgPicked = this.images[0].FileLocation
            }
          },
          response => {
            alert('error')
          }
        )
    },
    service_jule_action () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'service_invite_action', salesPerson: this.salesPerson, levid: this.haaId, customers: JSON.stringify(this.customers), imgPicked: this.imgPicked, bcc: this.consent}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
              }
              this.customers = []
              this.customers.push(Vue.util.extend({}, this.customer))
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    addCustomer () {
      this.customers.push(Vue.util.extend({}, this.customer))
    },
    delCustomer (index) {
      Vue.delete(this.customers, index)
    }
  },
  created () {
    this.customers.push(Vue.util.extend({}, this.customer))
    this.Reload()
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// invite.vue?e2b67f80